export const contactsData = {
  email: "alakmodak99@gmail.com",
  phone: "+91 9366190996",
  address: "Agartala, Tripura, India",
  sheetAPI: "",
  googleFormURL:
    "https://docs.google.com/forms/u/0/d/e/1FAIpQLScdEqGuHQwiNbr80kNVJae5ZMTEs0qxapjoLLrRUgHQJ86zCg/formResponse",
  googleFormFields: {
    email: "emailAddress", // Google Forms uses "emailAddress" for email field
    name: "entry.2073256368", // Name field entry ID
    message: "entry.720254457", // Message field entry ID
  },
};
